import { Fragment } from "react";
import { Descriptions, Spin, List, Divider } from "antd";
import moment from "moment";
import { useParams } from "react-router-dom";
import { useRequest } from "ahooks";
import { useSelector } from "react-redux";
import { announcement as announcementService } from "@/services";
import { useAuthContext } from "@/components/auth/AuthProvider";
import "braft-editor/dist/output.css";
import styles from "./index.module.less";

function AnnouncementDetail() {
  const { department_name } = useSelector((state) => state.user.user);
  const { announcementId } = useParams();

  const auth = useAuthContext();
  const { data, loading } = useRequest(
    () => {
      return announcementService.getAnnouncement(announcementId, auth.token);
    },
    {
      ready: !!announcementId && !!auth,
      refreshDeps: [announcementId],
    }
  );
  return (
    <div className={styles.announcementDetail}>
      <div className="announcement-title">公告详情</div>
      <div className="announcement-body">
        <Spin spinning={loading}>
          <Descriptions
            bordered
            column={2}
            size="middle"
            labelStyle={{ width: 120 }}
          >
            <Descriptions.Item label="栏目">
              {data?.column_name}
            </Descriptions.Item>
            <Descriptions.Item label="类型">
              {data?.type_name}
            </Descriptions.Item>
            {data && data.sender === auth.department_id && (
              <Descriptions.Item label="接收单位" span={2}>
                {data?.records.length !== 0 &&
                  data?.records.map((r) => r.department.name).join(", ")}
              </Descriptions.Item>
            )}
            <Descriptions.Item label="标题" span={2}>
              {data?.title}
            </Descriptions.Item>
            <Descriptions.Item label="内容" span={2}>
              <div
                className="braft-output-content"
                dangerouslySetInnerHTML={{ __html: data?.content }}
              ></div>
            </Descriptions.Item>
            <Descriptions.Item label="附件" span={2}>
              {data?.attachments?.length !== 0 && (
                <ol style={{ margin: 0, padding: 0 }}>
                  {data?.attachments?.map((a) => (
                    <li key={a.id}>
                      {a.name}{" "}
                      <a
                        href={`/api/polls/announcement?id=${a.id}&t=${btoa(
                          encodeURIComponent(department_name)
                        )}`}
                        rel="noreferrer"
                        target="_blank"
                      >
                        下载
                      </a>
                    </li>
                  ))}
                </ol>
              )}
            </Descriptions.Item>
            <Descriptions.Item label="发布日期" span={2}>
              {data && moment(data.published_at).format("YYYY-MM-DD HH:mm")}
            </Descriptions.Item>
            <Descriptions.Item label="联系人">
              {data?.contacts}
            </Descriptions.Item>
            <Descriptions.Item label="联系电话">
              {data?.contact_number}
            </Descriptions.Item>
          </Descriptions>
        </Spin>
        {data && data.sender === auth.department_id && (
          <Fragment>
            <Divider />
            <List
              size="small"
              header={<div>阅读记录</div>}
              bordered
              dataSource={data.records}
              renderItem={(item) => (
                <List.Item actions={item.is_read ? ["已读"] : ["未读"]}>
                  {item.department.name}
                </List.Item>
              )}
            />
          </Fragment>
        )}
      </div>
    </div>
  );
}

export default AnnouncementDetail;
